import script from "./ProductSafetyInfosSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetyInfosSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetyInfosSkeleton.vue?vue&type=style&index=0&id=7c7fd96a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7fd96a"]])

export default __exports__